import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useMutation } from "react-query";
import CircularProgress from "@mui/material/CircularProgress";

import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import EventNoteOutlinedIcon from "@mui/icons-material/EventNoteOutlined";

import * as api from "../../services";
import {
  Avatar,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { stringToHslColor } from "../../tools";
import SearchField from "../../Components/SearchField";
import { useContext } from "react";
import AppContext from "../../appContext";

export default function ChooseProtocol({
  protocolDispatch,
  handleNext,
  handleClose,
}) {
  const {
    app: {
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const { t } = useTranslation();
  const [search, setSearch] = useState("");
  const [templates, setTemplates] = useState(null);

  const searchMutation = useMutation((data) => api.postSearchClient(data), {
    onSuccess: (data) => {
      if (data.data?.status > 0) {
        setTemplates(data.data.clients);
      }
    },
  });

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      searchMutation.mutate({
        s: "templates",
        q: search,
        projectId,
        sessionId,
      });
    }, 400);
    return () => {
      clearTimeout(timeOutId);
    };
  }, [search]);

  const handleListItemClick = (id) => {
    protocolDispatch({ type: "SET_PROTOCOL_ID", payload: id }); // store the templateId
    handleNext(); // go to next screen in wizard
  };

  return (
    <Box maxHeight={300}>
      <Box display="flex" gap={1} alignItems="center">
        <IconButton onClick={handleClose} size="small" sx={{ padding: 1 }}>
          <CloseOutlinedIcon fontSize="small" />
        </IconButton>
        <Typography variant="h6">{t("protocol.choose")}</Typography>
      </Box>
      <Box padding={1} />
      <SearchField setUserText={setSearch} placeholder={t("protocol.search")} />
      {templates === null ? ( // loading
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height={250}
        >
          <CircularProgress />
        </Box>
      ) : (
        <List>
          {templates.length > 0 ? (
            templates.map(
              (
                template // loaded
              ) => (
                <ListItem
                  key={template.id}
                  button
                  onClick={() => handleListItemClick(template.id)}
                  sx={{ borderRadius: 1 }}
                >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: stringToHslColor(template.alias) }}>
                      <EventNoteOutlinedIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={template.alias} secondary="" />
                </ListItem>
              )
            )
          ) : (
            // no results found
            <ListItem>
              <ListItemText primary={t("protocol.noSearchResults")} />
            </ListItem>
          )}
        </List>
      )}
    </Box>
  );
}
